import React, { useState, useEffect } from "react";
import moment from "moment";
import {
    LineChart,
    Line,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    ReferenceArea,
    ReferenceLine,
    Tooltip
} from 'recharts';
import {
    ConvertData, CustomTooltip, getGroupedSeriesByUUID, getGroupedSeriesByGroupmentAndSerie,
    GetXLSXData, createOccupationArea, CustomizedReferenceLabel, convertUrlColorToHexa
} from './ChartsV2Functions';
import "./ChartV2.css";
import uuid from "react-uuid";

export default function ChartV2LineTimeAxis(props) {
    const { chart, data, setData, entityParameters, displayOccupationSchedule } = props;
    const [activelegend, setActivelegend] = useState([]);
    const [groupedseries, setGroupedseries] = useState([]);
    const [zoomed, setZoomed] = useState(false);
    const [zoomObject, setZoomObject] = useState({
        refAreaLeft: '',
        refAreaRight: '',
    });
    const [displayeddata, setDisplayeddata] = useState([]);
    const [occupationareas, setOccupationareas] = useState([]);

    // let movement_timer = null;
    // const RESET_TIMEOUT = 100;

    useEffect(() => {
        chart.series.forEach((serie) => {
            serie.uuid = uuid();
            serie.color = convertUrlColorToHexa(serie.color);
            // console.log(serie.color);
        });
        let datatmp = ConvertData(chart);
        setData(datatmp);
        setDisplayeddata(datatmp);
        let groupedseriestmp;
        if (!chart.distributiongroupment || chart.distributiongroupment === 'no') {
            groupedseriestmp = getGroupedSeriesByUUID(chart);
        }
        else
            groupedseriestmp = getGroupedSeriesByGroupmentAndSerie(chart);

        
        setGroupedseries(groupedseriestmp);
        let activelegendtmp = [];
        groupedseriestmp.forEach((serie) => {
            activelegendtmp.push({ dataKey: serie.groupid, hide: false });
        });
        groupedseriestmp.sort((a, b) => a.position - b.position);
        setActivelegend(activelegendtmp);
        GetXLSXData(chart, datatmp, groupedseriestmp);
        let occupationareastmp = createOccupationArea(datatmp, entityParameters);
        setOccupationareas(occupationareastmp);
    }, []);

    const handleMouseDown = (e) => {
        if (e && e.activeLabel) {
            setZoomObject(prev => ({
                ...prev,
                refAreaLeft: e.activeLabel
            }));
        }
    };
    const handleMouseMove = (e) => {
        if (e && e.activeLabel && zoomObject.refAreaLeft) {
            // clearInterval(movement_timer);
            // movement_timer = setTimeout(setZoomObject(prev => ({ ...prev, refAreaRight: e.activeLabel })), RESET_TIMEOUT);
            setZoomObject(prev => ({ ...prev, refAreaRight: e.activeLabel }));
        }
    };
    const handleMouseUp = (e) => {
        // let tmpzoomobject = { ...zoomObject };
        if (zoomObject.refAreaRight && zoomObject.refAreaLeft) {
            if (zoomObject.refAreaLeft > zoomObject.refAreaRight) {
                trunkdisplayeddata(zoomObject.refAreaRight, zoomObject.refAreaLeft);
            }
            else {
                trunkdisplayeddata(zoomObject.refAreaLeft, zoomObject.refAreaRight);
            }
            setZoomObject(prev => ({
                ...prev,
                refAreaLeft: '',
                refAreaRight: ''
            }));
        }
    };
    const trunkdisplayeddata = (left, right) => {
        let fromIndex = data.findIndex((x) => x.timestamp === left);
        let toIndex = data.findIndex((x) => x.timestamp === right);
        // console.log(fromIndex, toIndex, data.length);
        //next conditions and calculations to avoid empty zoom
        if (fromIndex > 0)
            fromIndex = fromIndex - 1;
        if (toIndex < (data.length - 1))
            toIndex = toIndex + 1;
        //console.log(fromIndex, (toIndex - 1));
        if (fromIndex < (toIndex - 2)) {
            const refData = data.slice(fromIndex, toIndex);
            //console.log(refData);
            setDisplayeddata(refData);
            setZoomed(true);
        }

    }


    const zoomOut = () => {
        setDisplayeddata(data);
        setZoomObject({
            refAreaLeft: '',
            refAreaRight: '',
        });
        setZoomed(false);
    }

    const handleLegendClick = (node) => {
        // console.log(node);
        node.inactive = !node.inactive;
        let activelegendtmp = [...activelegend];
        // console.log(activelegendtmp);
        activelegendtmp.find((legend) => legend.dataKey == node.dataKey).hide = !activelegendtmp.find((legend) => legend.dataKey == node.dataKey).hide;
        setActivelegend(activelegendtmp);
    };

    return (
        <>
            {zoomed ?
                <button type="button" className="zoomoutbutton" onClick={() => zoomOut()}>
                    Dézoomer
                </button> : <></>
            }
            <ResponsiveContainer width="100%" height="100%">
                <LineChart
                    width={500}
                    height={300}
                    data={displayeddata}
                    margin={{
                        top: 5,
                        right: 30,
                        left: 20,
                        bottom: 40,
                    }}
                    onMouseDown={e => handleMouseDown(e)}
                    onMouseMove={e => handleMouseMove(e)}
                    onMouseUp={(e) => handleMouseUp(e)}
                    onMouseLeave={e => setZoomObject(prev => ({
                        ...prev,
                        refAreaLeft: '',
                        refAreaRight: '',
                    }))}
                >
                    <defs>
                        <linearGradient id="greentored" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#8bbc21" stopOpacity={1} />
                            <stop offset="100%" stopColor="#c42525" stopOpacity={1} />
                        </linearGradient>
                    </defs>
                    <defs>
                        <linearGradient id="redtogreen" x1="0%" y1="0%" x2="100%" y2="0%">
                            <stop offset="0%" stopColor="#c42525" stopOpacity={1} />
                            <stop offset="100%" stopColor="#8bbc21" stopOpacity={1} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid
                        strokeDasharray="1"
                        vertical={false}
                    />
                    <XAxis
                        allowDataOverflow={true}
                        dataKey="timestamp"
                        type='number'
                        domain={["auto", "auto"]}
                        scale='time'
                        tickFormatter={(unixTime) => chart.xaxistimetick === 'day' ? moment(unixTime).utc().format('DD/MM/yyyy')
                            : chart.xaxistimetick === 'month' ? moment(unixTime).utc().format('MM/yyyy') : moment(unixTime).utc().format('DD/MM/yyyy')}
                        name='Date'
                        padding={'gap'}
                        angle={325}
                        tickMargin={25}
                        axisLine={false}
                    />
                    <YAxis
                        allowDataOverflow={true}
                        label={{ value: chart.yaxis1unit, angle: -90, position: 'insideLeft' }}
                        yAxisId="left"
                        orientation="left"
                        axisLine={false}
                        tickLine={false}
                        type="number"
                        // interval='equidistantPreserveStart'
                        // domain={["auto", "auto"]}
                        // domain={[(min) => {
                        //     return min > 0 ? 0 : min;
                        // }, "auto"]}
                        domain={([dataMin, dataMax]) => { 
                            const dif = (dataMax-dataMin)/10;
                            let min = 0;
                            if(dataMin>=0 && dataMin-dif<0)
                                min = 0;
                            else min = dataMin-dif;
                            let max = dataMax+dif;
                            return [Math.floor(min), Math.ceil(max)]; 
                        }}
                        tickFormatter={(value) => value > 10000 ? new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(value / 1000) + "k" : "" + new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(value)}
                    />
                    {
                        chart.yaxis2 ?
                            <YAxis
                                allowDataOverflow={true}
                                label={{ value: chart.yaxis2unit, angle: -90, position: 'insideRight' }}
                                yAxisId="right"
                                orientation="right"
                                axisLine={false}
                                tickLine={false}
                                domain={["auto", "auto"]}
                                tickFormatter={(value) => value > 10000 ? (value / 1000) + "k" : "" + value}
                            /> : <></>
                    }
                    <Tooltip
                        cursor={{ fill: 'transparent' }}
                        content={<CustomTooltip xaxistimetick={chart.xaxistimetick}/>}
                    />
                    {displayOccupationSchedule ? occupationareas : <></>}
                    {zoomObject.refAreaLeft && zoomObject.refAreaRight ? (
                        <ReferenceArea x1={zoomObject.refAreaLeft} x2={zoomObject.refAreaRight} ifOverflow='hidden' yAxisId={'left'} strokeOpacity={1} />
                    ) : null}
                    {
                        chart.references?.map((ref) =>
                            <ReferenceLine ifOverflow={'extendDomain'} y={ref.value}
                                //label={ref.name}
                                isFront={true}
                                label={<CustomizedReferenceLabel text={ref.name} />}
                                yAxisId={ref.yaxis} stroke="black" />
                        )
                    }
                    <Legend
                        wrapperStyle={{ marginBottom: -40 }}
                        onClick={handleLegendClick}
                    />
                    {
                        groupedseries.map((serie) =>

                            <Line
                                type="monotone"
                                connectNulls
                                isAnimationActive={false}
                                background={false}
                                dataKey={serie.groupid}
                                dot={false}
                                strokeWidth={2}
                                stroke={serie.color}
                                name={serie.groupname}
                                hide={activelegend.find((legend) => legend.dataKey == (serie.groupid))?.hide}
                                yAxisId={serie.yaxis || 'left'}
                                unit={(serie.yaxis && serie.yaxis === 'right') ? chart.yaxis2unit : chart.yaxis1unit}
                            />
                        )
                    }

                </LineChart>

            </ResponsiveContainer>
        </>
    );
}